import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'dodge_chance',
    apply: ({ state, source, params }) => {
        const chance = params.chance ?? 0.15;
        getRuntimes(state, source.side)[source.slot].statuses.push({
            id: `dodge_${source.slot}`,
            kind: 'dodge_chance',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { chance }
        });
    }
});
